<template>
  <layout-block :has-border="false" :width="width" margin="48px 16px">
    <layout-block-head :title="performance.title" padding-top="8px" padding-bottom="0" />
    <ui-legend :label="performance.legend" v-if="performance.legend" />
    <div
      :style="{
        display: flex ? 'flex' : null,
        flexWrap: flex ? 'wrap' : null,
        justifyContent: flex ? 'space-between' : null,
      }"
    >
      <div
        v-for="(n, idx) in performance.data"
        :key="`performance-${idx}`"
        :style="{
          width: flex ? 'calc(50% - 1px)' : '100%',
        }"
      >
        <!-- Network Best Reviews Local Business Title-->
        <layout-block-title :title="n.title" padding="16px 0 " :color="'#06152F'" :key="`performance-title-${idx}`" />
        <layout-block-section margin="0 " :key="`performance-section-${idx}`">
          <table
            width="100%"
            style=" border-radius: 5px;border-collapse: collapse;"
            :style="{ backgroundColor: n.type === 'best' ? 'rgba(5,147,71,.1)' : 'rgba(202,42,29,.1)' }"
          >
            <tr v-for="(d, j) in n.data" :key="`performance-data-${idx}-${j}`">
              <td style="padding: 6px 8px 6px 16px; color: #06152F;font-size: 16px;" align="left">
                {{ truncate(d.name, flex ? 13 : 22) }}
              </td>
              <td style=" padding: 0 8px; color: #06152F;font-size: 16px; font-weight: bold;" align="right">
                {{ d.value }}
                <img
                  src="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/comment.png"
                  width="16px"
                  v-if="n.category === 'reviews'"
                />
                <img
                  src="https://gatoreviews-emails.s3.eu-west-3.amazonaws.com/generic/icon-star.png"
                  width="16"
                  v-else-if="n.category === 'grade'"
                  style="margin: auto 0;"
                />
              </td>
              <td style="padding-right: 4px;" height="30" align="center">
                <ui-trend :trend="d.trend" :hasBg="false" />
              </td>
            </tr>
          </table>
        </layout-block-section>
      </div>
    </div>

    <ui-button :label="performance.cta.label" :href="performance.cta.url" v-if="performance.cta" margin="52px 0 0 0 " />
  </layout-block>
</template>

<script>
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutBlockHead from '@/components/Layout/Block/Head.vue'
import LayoutBlockSection from '@/components/Layout/Block/Section.vue'
import LayoutBlockTitle from '@/components/Layout/Block/Title.vue'
import UiButton from '@/components/UI/Button.vue'
import UiLegend from '@/components/UI/Legend.vue'
import UiTrend from '@/components/UI/Trend.vue'

export default {
  name: 'ReportPerformance',
  components: {
    LayoutBlock,
    LayoutBlockHead,
    LayoutBlockSection,
    LayoutBlockTitle,
    UiButton,
    UiLegend,
    UiTrend,
  },
  props: {
    flex: {
      type: Boolean,
      default: false,
    },
    performance: {
      type: Object,
      required: true,
    },
    width: {
      type: String,
      default: 'auto',
    },
  },
  methods: {
    truncate(source, size) {
      return source.length > size ? source.slice(0, size - 1) + '…' : source
    },
  },
}
</script>
